import { jsx as _jsx } from "react/jsx-runtime";
// Indented a little so a help line reads as belonging to the control above it
// rather than sitting flush with it as another thing in the column.
export function FieldHelp({ children }) {
    return _jsx("p", { className: "pl-1 text-xs text-muted-foreground", children: children });
}
//# sourceMappingURL=FieldHelp.js.map